import { render, staticRenderFns } from "./App.vue?vue&type=template&id=486b1446"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=486b1446&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports